import React, { useEffect, useState } from "react";
import CustomTable from "../../../Components/Table/CustomTable";

import { Grid } from "@mui/material";

import UserRoleCreateModal from "../Modal/UserRoleCreateModal";
import { setHeaderName, setSubHeaderName } from "../../../ReduxStore/Slices/headerSlice";
import actions from "../../../ReduxStore/actions/index";
import { useDispatch, useSelector } from "react-redux";
import { format } from 'date-fns';

const UserRole = () => {
  const dispatch = useDispatch()

  const { createRoleWithPermissions } = useSelector(
    (state) => state?.createRoleWithPermissions
  );
  const tableData = [
    {
      Name: "Vallarasu",
      Email: "valla@gmail.com",
      MobileNumber: "1232343444",
      UserType: "Individual",
      Status: "Approved",
    },
    {
      Name: "Pravin",
      Email: "pravin@gmail.com",
      MobileNumber: "98787687687",
      UserType: "Individual",
      Status: "Approved",
    },
    {
      Name: "Shahul",
      Email: "shahul@gmail.com",
      MobileNumber: "123322443543",
      UserType: "Individual",
      Status: "Approved",
    },

  ];
  const tableHeadData = [
    "S.No",
    "Role Name",
    // "Role Id",
    "Modules Access",
  ];

  const { updateAllPermissionsForAuthUser } = useSelector((state) => state?.updateAllPermissionsForAuthUser);


  const { getAllRolesWithModules } = useSelector(
    (state) => state?.getAllRolesWithModules
  );
  useEffect(() => {
    const fetchData = async () => {
      const data1 = {
        data: {},
        method: "get",
        apiName: `getAllRolesWithModules`,
      };
      await dispatch(actions.GETALLROLESWITHMODULES(data1));
    };
    fetchData();
  }, [dispatch, createRoleWithPermissions, updateAllPermissionsForAuthUser]);

  const [rowTableData, setRowTableData] = useState([
    {
      roleName: "--",
      role_id: "--",
      modules: "--",

    },
  ]);

  useEffect(() => {
    const tempArr = [];
    getAllRolesWithModules?.data?.map((data, index) => {
      return tempArr.push({
        roleName: data?.roleName,
        role_id: data?.role_id,
        modules: `${data?.modules[0] ?? " No permissions"}, ${data?.modules[1] ?? ""}, ${data?.modules[2] ?? ""}`,
      });
    });
    setRowTableData(tempArr);
  }, [
    dispatch, getAllRolesWithModules, createRoleWithPermissions, updateAllPermissionsForAuthUser
  ]);



  const editData = {
    userrole: "Admin",
    status: "inactive",
    permissions: {
      Dashboard: {
        Dashboard: { add: true, edit: true, delete: false, view: false },
      },
      OperatorRegistration: {
        "All User List": {
          add: true,
          edit: false,
          delete: false,
          view: false,
        },
        "Purchaser List": {
          add: false,
          edit: false,
          delete: false,
          view: false,
        },
        "Referrer List": {
          add: false,
          edit: false,
          delete: false,
          view: false,
        },
        "Financial Consultant List": {
          add: false,
          edit: false,
          delete: false,
          view: false,
        },
      },
      SchemeManagement: {
        "Gold Stake Schemes": {
          add: false,
          edit: false,
          delete: false,
          view: false,
        },
        // "Referral Schemes": {
        //   add: false,
        //   edit: false,
        //   delete: false,
        //   view: false,
        // },
      },
      ContentManagement: {
        Home: { add: false, edit: false, delete: false, view: false },
        "Stake Now": { add: false, edit: false, delete: false, view: false },
        Referrals: { add: false, edit: false, delete: false, view: false },

        "About Us": { add: false, edit: false, delete: false, view: false },
        Blog: { add: false, edit: false, delete: false, view: false },
        "Contact Us": { add: false, edit: false, delete: false, view: false },
      },
    },
  };


  React.useEffect(() => {
    dispatch(setHeaderName("Master"));
    dispatch(setSubHeaderName("User Role"));
  }, []);


  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ width: "100px" }}>
        <CustomTable
          tableData={rowTableData}
          title="User Roles"
          tableHeadData={tableHeadData}
          modalName={UserRoleCreateModal}
          modalHeadingName="Create User Role"
          tableEdit="tableEdit"
          // tableDelete="tableDelete"
          editModalName={UserRoleCreateModal}
          dataCreate={true}


        // editData={editData}
        // modalVeiwName={PurchaseApprovalModalView}
        //   notModalTable="notModalTable"
        //   tableEdit="tableEdit"
        // tableView="tableView"
        // modalViewHeadingName=""
        />
      </Grid>
    </Grid>
  );
};

export default UserRole;
